import Vue from 'vue'

Vue.use({

	install (Vue) {
		Vue.prototype.$generateMetaInfo = ({ title, description, image }) => {
			const metaInfo = {
				title,
				meta: []
			}
			if(title) {
				metaInfo.meta.push({ property: 'og:title', content: title })
			}
			if(description) {
				metaInfo.meta.push(...[
					{ name: 'description', content: description },
					{ property: 'og:description', content: description }
				])
			}
			if(image) {
				metaInfo.meta.push({
					property: 'og:image',
					content: (image.startsWith('http')) ? image : `${window.location.protocol}${image}`
				})
			}
			return metaInfo
		}
	}

})

export default {}



// WEBPACK FOOTER //
// ./src/initializers/metaInfo.js